import React, { useEffect, useState } from 'react'
import { Row, Col, Container } from 'reactstrap'
import CallIcon from '../assets/images/Call Icon.png'
import MailIcon from '../assets/images/Mail Icon.png'
import LocationIcon from '../assets/images/Location Icon.png'
import swal from 'sweetalert'
import axios from 'axios'
import { checkStringContains, baseURL } from './domainValidator'



export default function Contact() {
const [emailDomainData, setEmailDomainData] = useState([])

  const [name, setName] = useState(null)
  const [lastName, setLastName] = useState(null)
  const [designation, setDesignation] = useState(null)
  const [phoneNo, setPhoneNo] = useState(null)
  const [domain, setDomain] = useState(null)
  const [workMail, setWorkmail] = useState(null)
  const [subject, setSubject] = useState(null)

  const [nameError, setNameError] = useState(null)
  const [lastNameError, setLastNameError] = useState(null)
  const [designationError, setDesignationError] = useState(null)
  const [phoneNoError, setPhoneNoError] = useState(null)
  const [domainError, setDomainError] = useState(null)
  const [workMailError, setWorkmailError] = useState(null)
  const [subjectError, setSubjectError] = useState(null)
  const [disableSubmitNow, setDisableSubmitNow] = useState(false)

   const getDomainNameData=()=>{
          const headers = {headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Frame-Options': 'DENY'}};
          fetch(`${baseURL}/getEmailDomains`, headers)
              .then(res => res.json())
              .then(json =>{
                setEmailDomainData(json.data.email_domains)
              }).catch((error) => {
                console.error("Error fetching data:", error);
            });
        }

  const validation = () => {

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // const nameFieldRegex = /[0-9!@#$%^&*()\-+={}[\]:;"'<>,.?\/|\\]/;
    const nameFieldRegex = /^[^\s].+[a-zA-Z]+[a-zA-Z]+$/;
    const mumberFieldRegex =  /^(?!00)[0-9]*$/ // /^(\+\d{1,3}[- ]?)?\d{10,13}$/;
    const domainNameRegex = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
    let validated = true;
    if (!name) {
      const nameError = "Please Enter your First Name";
      setNameError(nameError)
      validated = false;
    } else {
      if (!nameFieldRegex.test(name)) {
        const nameError = "Please Enter valid First Name";
        setNameError(nameError)
        validated = false;
      } else {
        
        const nameError = "";
        setNameError(nameError)
      }
    }
    if (!lastName) {
      const lastNameError = "Please Enter your Last Name";
      setLastNameError(lastNameError)
      validated = false;
    } else {
      if (!nameFieldRegex.test(lastName)) {
        const lastNameError = "Please Enter your Valid Last Name";
        setLastNameError(lastNameError)
        validated = false;
      } else {
        const lastNameError = "";
        setLastNameError(lastNameError)
      }
    }
    if (!designation) {
      const designationError = "Please Enter your Designation";
      setDesignationError(designationError)
      validated = false;
    } else {
      if (!nameFieldRegex.test(designation)) {
        const designationError = "Please Enter your Valid Designation";
        setDesignationError(designationError)
        validated = false;
      } else {
        const designationError = "";
        setDesignationError(designationError)
      }
    }
    if (!domain) {
      const domainError = "Please Enter your Org. Name";
      setDomainError(domainError)
      validated = false;
    } else {
      // if (!domainNameRegex.test(domain)) {
      //   const domainError = "Please Enter valid Org. Name";
      //   setDomainError(domainError)
      //   validated = false;
      // } else {
      //   const domainError = "";
      //   setDomainError(domainError)
      // }
      const domainError = "";
        setDomainError(domainError)
    }
    if (!workMail) {
      const workMailError = "Please Enter your  Workmail Id";
      setWorkmailError(workMailError)
      validated = false;

    } else {
      if (!emailRegex.test(workMail)) {
        const workMailError = "Please Enter valid Workmail Id";
        setWorkmailError(workMailError)
        validated = false;
      } else {
        console.log(emailDomainData, 'emailDomainDataemailDomainDataemailDomainData');
        
        let temptValidator= checkStringContains(emailDomainData, workMail)
        if (temptValidator === false) {
          const workMailError = "Please Enter valid Workmail Id";
          setWorkmailError(workMailError)
          validated = false;
        } else {
          const workMailError = "";
          setWorkmailError(workMailError)
        }
      }
    }
    if (!subject) {
      const subjectError = "Please Enter the Message";
      setSubjectError(subjectError)
      validated = false;
    } else {
      const subjectError = "";
      setSubjectError(subjectError)
    }
    if (!phoneNo) {
      const phoneNoError = "";
      setPhoneNoError(phoneNoError)
    } else {
      if (!mumberFieldRegex.test(phoneNo)) {
        const phoneNoError = "Please Enter Valid Number";
        setPhoneNoError(phoneNoError)
        validated = false;
      } else {
        const phoneNoError = "";
        setPhoneNoError(phoneNoError)
      }
    }
    return validated;
  }


  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === 'name') {
      setName(value)
    }
    if (name === 'domain') {
      setDomain(value)
    }
    if (name === 'workMail') {
      setWorkmail(value)
    }
    if (name === 'subject') {
      setSubject(value)
    }
    if (name === 'lastName') {
      setLastName(value)
    }
    if (name === 'phoneNo') {
      setPhoneNo(value)
    }
    if (name === 'designation') {
      setDesignation(value)
    }
  }

  const handleSubmit = () => {
    // console.log(name, lastName, domain, designation, workMail, phoneNo, subject);


    const valid = validation()

    if (valid) {
      setDisableSubmitNow(true)
      axios.post(`${baseURL}/contactUs`, {
        firstName: name,
        lastName: lastName,
        organisation: domain,
        designation: designation,
        mail: workMail,
        phoneNo: phoneNo,
        subject: subject
      })
        .then(function (response) {

          swal('Success', `${response?.data?.message}`, 'success')
          console.log(response);
          setName("")
          setLastName("")
          setDesignation("")
          setPhoneNo("")
          setDomain("")
          setWorkmail("")
          setSubject("")

          setNameError('')
          setLastNameError('')
          setDesignationError('')
          setPhoneNoError('')
          setDomainError('')
          setWorkmailError('')
          setSubjectError('')

          setDisableSubmitNow(false)
        })
        .catch(function (error) {
          console.log(error);
          swal('Error', `something went wrong`, 'error')
          setName("")
          setLastName("")
          setDesignation("")
          setPhoneNo("")
          setDomain("")
          setWorkmail("")
          setSubject("")

          setNameError('')
          setLastNameError('')
          setDesignationError('')
          setPhoneNoError('')
          setDomainError('')
          setWorkmailError('')
          setSubjectError('')
          setDisableSubmitNow(false)
        })
        .finally(()=>{
          setName('') 
          setLastName('')
          setDesignation('')
          setPhoneNo('')
          setDomain('') 
          setSubject('') 
          setNameError('')
          setLastNameError('')
          setDesignationError('') 
          setDomainError('') 
          setWorkmailError('')
        });
    }
  }

  useEffect(() => {
    getDomainNameData()
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className='conatct px-3 pb-5 '>
        <div className='conatct'>
          <Container>
            <Row>
              
              {
                window.location.pathname === '/contact' ? null :
                <Col sm={12} className='text-center'>
                <h1 className='mb-5 archivo-normal font-45'>Get in Touch with Our Experts</h1>
                {/* <p className='mb-5'>Fill out the form below with your details, and our team will get back to you shortly.</p> */}
              </Col> 
              }
              
              <Col sm={12} md={6} xl={6} >
                <div className='contact-box bg-gray-light float-end py-5'>
                  <div className='d-flex contact-item mb-4'>
                    <div className='contact-icon bg-cyan'>
                      <img src={MailIcon} />
                    </div>
                    <div className='px-3 py-2'>
                      <h4 className='mb-1'>Write Us</h4>
                      <small className='font-16'>contact@agilustech.in</small>
                    </div>
                  </div>
                  <div className='d-flex contact-item mb-4'>
                    <div className='contact-icon bg-blue'>
                      <img src={CallIcon} />
                    </div>
                    <div className='px-3 py-2'>
                      <h4 className='mb-1'>Call Us</h4>
                      <small className='font-16'>+91 97175 93213</small>
                    </div>
                  </div>
                  <div className='d-flex contact-item'>
                    <div className='contact-icon bg-pink'>
                      <img src={LocationIcon} />
                    </div>
                    <div className='px-3 py-2'>
                      <h4 className='mb-1'>Locate Us</h4>
                      <small className='font-16'>A-25, Sector 67, Noida</small>
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm={12} md={6} xl={6} >
                <div className='conatct-form py-4 inter-regular'>
                  <Row className='mt-4'>
                    <Col sm={6} className='position-relative'>
                      <span className='position-absolute error-position'>{nameError}</span>
                      <input maxLength={51} value={name} onChange={handleChange} placeholder='First Name' className='form-control mb-3' name='name' style={{ borderColor: nameError ? 'red' : '' }} />
                    </Col>
                    <Col sm={6} className='position-relative'>
                      <span className='position-absolute error-position'>{lastNameError}</span>
                      <input maxLength={51} value={lastName} onChange={handleChange} placeholder='Last Name' className='form-control mb-3' name='lastName' style={{ borderColor: lastNameError ? 'red' : '' }} />
                    </Col>

                    <Col sm={6} className='position-relative'>
                      <span className='position-absolute error-position'>{domainError}</span>
                      <input value={domain} maxLength={100} onChange={handleChange} placeholder='Organisation' className='form-control mb-3' name='domain' style={{ borderColor: domainError ? 'red' : '' }} />
                    </Col>
                    <Col sm={6} className='position-relative'>
                      <span className='position-absolute error-position'>{designationError}</span>
                      <input value={designation} maxLength={100} onChange={handleChange} placeholder='Designation' className='form-control mb-3' name='designation' style={{ borderColor: designationError ? 'red' : '' }} />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6} className='position-relative'>
                      <span className='position-absolute error-position'>{workMailError}</span>
                      <input value={workMail} maxLength={100} onChange={handleChange} placeholder='Official Email ID' className='form-control mb-3' name='workMail' style={{ borderColor: workMailError ? 'red' : '' }} />
                    </Col>
                    <Col sm={6} className='position-relative'>
                      <span className='position-absolute error-position'>{phoneNoError}</span>
                      <input maxLength={10} value={phoneNo} onChange={handleChange} placeholder='Phone No.' className='form-control mb-3' name='phoneNo' style={{ borderColor: phoneNoError ? 'red' : '' }}/>
                    </Col>


                    <Col sm={12} className='position-relative'>
                      <span className='position-absolute error-position'>{subjectError}</span>
                      {/* <label>Drop your message<span className='text-danger'>*</span></label>  */}
                      <textarea rows="2" cols="50" value={subject} onChange={handleChange} placeholder='Drop your message' className='form-control mb-3' name='subject' style={{ borderColor: subjectError ? 'red' : '' }} />
                    </Col>
                    <Col sm={12}>
                      <button className='btn-custom p-3 d-block w-100 font-16 border-0' onClick={handleSubmit} disabled={disableSubmitNow}>Submit</button></Col>
                  </Row>





                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </>

  )
}